import React from "react"

import { type IconProps } from "./utils"

export default function CalendarClock(props: IconProps) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8563 5.09204C11.7764 4.63879 11.3442 4.33615 10.8909 4.41607L3.50488 5.71843C3.05164 5.79835 2.749 6.23057 2.82891 6.68381L2.97362 7.50449L12.001 5.91271L11.8563 5.09204ZM3.26304 9.14583L3.98657 13.2492C4.06649 13.7024 4.4987 14.0051 4.95195 13.9252L7.7707 13.4281C7.5949 12.8724 7.50008 12.2807 7.50008 11.6668C7.50008 10.3672 7.92511 9.16677 8.64375 8.19707L3.26304 9.14583ZM13.6664 5.84283C13.6633 5.77017 13.6553 5.69687 13.6424 5.6233L13.4977 4.80263C13.2579 3.44289 11.9613 2.53497 10.6015 2.77473L3.21547 4.07709C1.85573 4.31685 0.94781 5.61349 1.18757 6.97323L2.34522 13.5386C2.58498 14.8983 3.88163 15.8063 5.24136 15.5665L8.53557 14.9857C9.58859 16.5051 11.3448 17.5002 13.3334 17.5002C16.5551 17.5002 19.1667 14.8885 19.1667 11.6668C19.1667 8.55692 16.7331 6.01543 13.6664 5.84283ZM13.3334 7.50015C11.0322 7.50015 9.16674 9.36563 9.16674 11.6668C9.16674 13.968 11.0322 15.8335 13.3334 15.8335C15.6346 15.8335 17.5001 13.968 17.5001 11.6668C17.5001 9.36563 15.6346 7.50015 13.3334 7.50015ZM13.3334 9.16682C13.7936 9.16682 14.1667 9.53992 14.1667 10.0002V11.3216L15.3116 12.4665C15.637 12.7919 15.637 13.3195 15.3116 13.645C14.9861 13.9704 14.4585 13.9704 14.133 13.645L12.7442 12.2561C12.5879 12.0998 12.5001 11.8878 12.5001 11.6668V10.0002C12.5001 9.53992 12.8732 9.16682 13.3334 9.16682Z"
        fill="currentColor"
      />
    </svg>
  )
}
